import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useApi } from '../../hooks/useApi';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const { post, loading } = useApi();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const data = await post('login', {
        Email: email,
        PasswordHash: password,
      });

      console.log(data);

      if (!data || !data.token) {
        setError('Credenciales inválidas');
        return;
      }

      localStorage.setItem('token', data.token);
      login(data.usuario, data.token);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Error en la conexión');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-qualtia from-blue-500 to-purple-600">
      <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md">
        <div className="text-center mb-6">
          <img
            src="assets/images/logo/logoQA.png"
            alt="logo"
            className="w-40 inline-block"
          />
          <h3 className="font-bold">HUB de Pedidos</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Correo electrónico
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="correo@ejemplo.com"
            />
          </div>
          <div className="mb-6">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 px-4 rounded-md transition ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
          >
            {loading ? 'Validando...' : 'Iniciar sesión'}
          </button>
        </form>
        {error && <p className="mt-4 text-center text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
}
